import { CanDeactivate } from "@angular/router";
import { FeatureCanvasComponent } from "./feature-canvas.component";
import { MzModalService } from "ng2-materialize";
import { ConfirmLeaveBacklogUnsyncedComponent } from "../confirm-leave-backlog-unsynced/confirm-leave-backlog-unsynced.component";
import { Observable } from "rxjs/Observable";

export class FeatureCanvasConfirmDeactivateGuard
  implements CanDeactivate<FeatureCanvasComponent> {
  canDeactivate(target: FeatureCanvasComponent): Observable<boolean> {
    return target.project && target.project.unsyncedChanges
      ? (<ConfirmLeaveBacklogUnsyncedComponent>(
          target.modalService.open(ConfirmLeaveBacklogUnsyncedComponent)
            .instance
        )).result.asObservable()
      : Observable.of(true);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/feature-canvas/confirm-deactivate.guard.ts